"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : TEXT AND GRAPHIC LAYOUT : STYLES --------------- ++++++++++ */


var _default = {
  textandgraphiclayout: {
    padding: (0, _index.replacePXinStringWithEM)("50px ".concat(_index.theme.spacing.sides)),
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'space-around',
    // ------ message ------ //
    '& .group.name-message': {
      // background: 'radial-gradient(ellipse at center,  rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%)', /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      opacity: '0',
      animationName: 'fadeInLeft',
      animationDuration: '.15s',
      animationFillMode: 'forwards',
      animationDelay: '.1s',
      flex: '1',
      marginBottom: (0, _index.pxToEm)(80),
      // headline
      '& .headline': {
        '& h1': {
          color: _index.theme.color.primary.medium.swatch,
          fontSize: (0, _index.pxToEm)(70),
          fontWeight: '600',
          lineHeight: '1',
          margin: "".concat((0, _index.pxToRem)(40), " 0 ").concat((0, _index.pxToRem)(25))
        }
      },
      // title
      '& .title': {},
      // bodycopy
      '& .bodycopy': {
        color: 'rgba(6, 43, 117, .5)'
      }
    },
    // ----- visual ----- //
    '& .group.name-visual': {
      marginLeft: (0, _index.pxToEm)(50),
      opacity: '0',
      animationName: 'fadeInRight',
      animationDuration: '.15s',
      animationFillMode: 'forwards',
      animationDelay: '.1s',
      '& .illustration': {
        fontSize: '40%' // customize per illustration

      }
    }
  }
};
exports.default = _default;